import { render, staticRenderFns } from "./area-default.md?vue&type=template&id=cbc1bb3a&"
import script from "./area-default.md?vue&type=script&lang=js&"
export * from "./area-default.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbc1bb3a')) {
      api.createRecord('cbc1bb3a', component.options)
    } else {
      api.reload('cbc1bb3a', component.options)
    }
    module.hot.accept("./area-default.md?vue&type=template&id=cbc1bb3a&", function () {
      api.rerender('cbc1bb3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/Area/area-default.md"
export default component.exports